export const getClientKey = () => {
  const isDevMode = import.meta.env.VITE_DEV_MODE === 'true';
  const clientKey = import.meta.env.VITE_CLIENT_KEY;
  const localClient = JSON.parse(localStorage.getItem('localClient'));
  const localClientKey = localClient?.apiKey;

  if (isDevMode && localClientKey) {
    return localClientKey;
  }
  return clientKey;
};
